import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { List, ListItem, Button, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import SecureLS from 'secure-ls';
import { ExpandMore } from '@material-ui/icons';
import { isBlank, isScriptAdmin } from '../../../../../../common/common';

const useStyles = makeStyles(theme => ({
  root: {},
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  link: {
    display: 'block',
    width: '100%'
  },
  button: {
    color: theme.palette.text.primary,
    padding: '8px 10px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightMedium,
    textAlign: 'left',
    borderRadius: 8,
    borderLeft: '3px solid transparent'
  },
  icon: {
    color: theme.palette.icon,
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1)
  },
  active: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    backgroundColor: 'rgba(30, 91, 216, 0.08)',
    borderLeftColor: theme.palette.primary.main,
    '& $icon': {
      color: theme.palette.primary.main
    }
  },
  accordion: {
    '&:before': {
      display: 'none'
    },
    '&.Accordion-root:before': {
      display: 'none',
    },
    boxShadow: 'none',
    backgroundColor: 'transparent',
    width: '100%',
    '&.Mui-expanded': {
      margin: 0
    }
  },
  accordionSummary: {
    minHeight: 40,
    padding: theme.spacing(0, 0.5),
    '&.Mui-expanded': {
      minHeight: 40
    },
    '& .MuiAccordionSummary-content': {
      margin: 0,
      '&.Mui-expanded': {
        margin: 0
      }
    }
  },
  accordionDetails: {
    padding: theme.spacing(0, 0, 0, 1)
  }
}));

const secureLS = new SecureLS({encodingType: 'aes', encryptionSecret: process.env.AES_KEY});

const SidebarNav = props => {
  const { pages, className, ...rest } = props;

  const classes = useStyles();

  return (
    <List
      {...rest}
      className={clsx(classes.root, className)}
    >
      {
        pages.map(page => (!page.scriptAdminOnly || isScriptAdmin()) && (page.securityKey === null || secureLS.get('cloud_license.accessibles').indexOf(page.securityKey) !== -1) ? (
          isBlank(page.children) ? (
            <ListItem
              className={classes.item}
              key={page.title}
            >
              <a
                className={classes.link}
                href={page.href === window.location.pathname ? '#' : page.href}
              >
                <Button
                  activeclassname={classes.active}
                  className={clsx(classes.button, {
                    [classes.active]: window.location.pathname === page.href
                  })}
                >
                  <div className={classes.icon}>{page.icon}</div>
                  {page.title}
                </Button>
              </a>
            </ListItem>
          ) : (
            <React.Fragment key={page.title}>
              <Accordion className={classes.accordion}>
                <AccordionSummary
                  // square
                  expandIcon={<ExpandMore />}
                  className={classes.accordionSummary}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  transitionprops={{
                    timeout: 0
                  }}
                >
                  <Button
                    activeclassname={classes.active}
                    className={classes.button}
                  >
                    <div className={classes.icon}>{page.icon}</div>
                    {page.title}
                  </Button>
                </AccordionSummary>
                <AccordionDetails className={classes.accordionDetails}>
                  <List
                    {...rest}
                    className={clsx(classes.root, className)}
                  >
                    {
                      page.children.map((child, index) => {
                        return  (!child.scriptAdminOnly || isScriptAdmin()) && (child.securityKey === null || secureLS.get('cloud_license.accessibles').indexOf(child.securityKey) !== -1) ?(
                          <React.Fragment key={index}>
                            <a
                              className={classes.link}
                              href={child.href === window.location.pathname ? '#' : child.href}
                            >
                              <Button
                                activeclassname={classes.active}
                                className={clsx(classes.button, {
                                  [classes.active]: window.location.pathname === child.href
                                })}
                              >
                                <div className={classes.icon}>{child.icon}</div>
                                {child.title}
                              </Button>
                            </a>
                          </React.Fragment>
                        ) : null
                      })
                    }
                  </List>
                </AccordionDetails>
              </Accordion>
            </React.Fragment>
          )
        ):null)
      }
    </List>
  );
};

SidebarNav.propTypes = {
  className: PropTypes.string,
  pages: PropTypes.array.isRequired
};

export default SidebarNav;
